import axios from "axios";
import store from "../store";
import { getInstallations } from "./fetchInstallation";
const CancelToken = axios.CancelToken;
let cancels = {};
const isElectron = process.env.VUE_APP_ELECTRON === "true";

function getHostId() {
  return store.getters.installation?.hostId;
}

function cancelRequest(id) {
  if (cancels[id]) cancels[id]();
  cancels[id] = null;
}
let instance = axios.create({
  baseURL: "",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

let cancelableInstance = axios.create({
  baseURL: "",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
/**
 *
 * @param {import('axios').AxiosRequestConfig} config
 * @returns
 */
function interceptor(config) {
  // config.params = Object.assign(axiosParms || {},{tempid: localStorage.getItem('nocibe-tempid')})
  config.params = Object.assign(config.params || {}, {
    // userId: store.getState().user.nocibeId,
    lang: store.state.i18n.lang,
    configId: store.state.installation.installation?.id,
    // gift: store.getState().session['for-who']==='self'?0:1
  });
  config.headers = Object.assign(config.headers || {}, {
    apikey: process.env.VUE_APP_APIKEY,
    safetyCode: process.env.VUE_APP_SAFETY_CODE,
  });
  // NO FUNCINABAN BIEN LOS EP, pero deberia ponerse el hostId que toca!!!!
  if (config.params.hostId === undefined && config.setHostId !== false)
    config.params = Object.assign(config.params || {}, {
      hostId: getHostId(),
    });
  if (config.remove) {
    config.remove.forEach((key) => delete config.params[key]);
  }
  return config;
}
instance.interceptors.request.use(interceptor);
cancelableInstance.interceptors.request.use((config) => {
  /// CANCELABLE
  config.params = Object.assign(config.params || {}, {
    lang: store.state.i18n.lang,
  });
  let reqId = config.url.split("?")[0];
  cancelRequest(reqId);
  if (config.params.hostId === undefined)
    config.params = Object.assign(config.params || {}, {
      hostId: getHostId(),
    });

  config.cancelToken = new CancelToken((c) => (cancels[reqId] = c));
  return config;
});
cancelableInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (axios.isCancel(error)) console.log("Request canceled", error.message);
    else throw error;
  }
);

export async function getInstallation(installationName) {
  return getInstallations({
    apikey: process.env.VUE_APP_APIKEY,
    safetyCode: process.env.VUE_APP_SAFETY_CODE,
    appName: process.env.VUE_APP_ID,
    api_url: process.env.VUE_APP_APIURL,
  }).then((sensors) =>
    sensors.find((sensor) => sensor.installationName === installationName)
  );
}
export function getAllBrands() {
  let lang = "en";
  let path = `/brands/`;
  let cached = store.getters["brands/get"](lang, path);
  if (cached) return Promise.resolve(cached);
  return instance.get(process.env.VUE_APP_APIURL + path).then((response) => {
    // store.dispatch('cacheIngredients',response.data)
    store.dispatch("brands/save", { lang, path, objects: response.data });
    return response.data;
  });
}
export function getIngredient(id) {
  let lang = store.getters.lang;
  let cached = store.getters["ingredients/getById"](lang, id);
  if (cached) return Promise.resolve(cached);
  const response = instance
    .get(process.env.VUE_APP_APIURL + `/ingredients/${id}`)
    .then((response) => {
      return response.data;
    });
  store.dispatch("ingredients/saveById", { lang, object: response, id });
  return response;
}
const ingredientInfoMap = new Map();
/**
 *
 * @param {Number | String} id
 */
export function getMetaIngredientById(id) {
  // if (!isElectron)
  //   return instance
  //     .get(process.env.VUE_APP_APIURL + `/ingredients/${id}/info/`)
  //     .then((response) => {
  //       return response.data;
  //     });
  const lang = store.getters.lang;
  if (ingredientInfoMap.get(lang)?.get(id)) {
    return Promise.resolve(ingredientInfoMap.get(lang)?.get(id));
  }
  return instance
    .get(process.env.VUE_APP_APIURL + `/ingredients/info/`)
    .then((response) => {
      if (!ingredientInfoMap.get(lang)) ingredientInfoMap.set(lang, new Map());
      response.data.forEach((info) =>
        ingredientInfoMap.get(lang).set(info.id.toString(), info)
      );
      return ingredientInfoMap.get(lang).get(id.toString());
    });
}
export function getAllIngredients() {
  let lang = store.getters.lang;
  let cached = store.getters.getCachedIngredients();
  if (cached) return Promise.resolve(cached);
  return instance
    .get(process.env.VUE_APP_APIURL + `/ingredients/`)
    .then((response) => {
      store.dispatch("ingredients/save", {
        lang,
        path: "/ingredients/",
        objects: response.data,
      });
      return response.data;
    });
}

export function getPerfume(id) {
  if (isElectron) return getPerfumeByIdElectron(id);
  let lang = store.getters.lang;
  let cached = store.getters["perfumes/getById"](lang, id);
  if (cached) return Promise.resolve(cached);
  const response = instance
    .get(process.env.VUE_APP_APIURL + `/perfumes/${id}`)
    .then((response) => {
      store.dispatch("perfumes/saveById", { lang, object: response.data });
      return response.data;
    });
  return response;
}

// NEEDED FOR TEH CONCEPTS MODULES, hay que revisarlo, lo he hecho muy a saco sin "cache" ni "langs" ni nada...
export function getFamilies() {
  // let lang = store.getters.lang
  // let cached = store.getters.getCachedFamilies()
  // if (cached)
  //   return Promise.resolve(cached)
  return instance
    .get(process.env.VUE_APP_APIURL + `/families/`, { setHostId: true })
    .then((response) => {
      // store.dispatch('families/save', {lang, path:'/families/', objects:response.data})
      return response.data;
    });
}
export function getConcepts() {
  return instance
    .get(process.env.VUE_APP_APIURL + `/concepts/`, {
      params: { addOnly: "categories" },
    })
    .then((response) => {
      // store.dispatch('families/save', {lang, path:'/families/', objects:response.data})
      return response.data;
    });
}

export function getConceptSimilarities() {
  return (
    instance
      .get(
        process.env.VUE_APP_APIURL +
        `/file/precomputed?fileName=conceptsDistance`
      )
      // .get("http://localhost:3001/api/dufry_profiler/conceptsDistance")
      .then((response) => {
        // store.dispatch('families/save', {lang, path:'/families/', objects:response.data})
        Object.values(response.data).forEach((concept) =>
          Object.keys(concept).forEach((key) => {
            if (concept[key] === 0) concept[key] = 0.01;
            // if (concept[key] === 1) concept[key] = 0.99;
          })
        );
        return response.data;
      })
  );
}

export function getConceptPerfumes() {
  return (
    instance
      .get(
        process.env.VUE_APP_APIURL + `/file/precomputed?fileName=conceptsRecos`
      )
      // .get('http://localhost:3001/api/dufry_profiler/conceptsRecos')
      .then((response) => {
        // store.dispatch('families/save', {lang, path:'/families/', objects:response.data})
        return response.data;
      })
  );
}

/**
 * Get array of perfumes with parameter ids
 * @param {string[]} ids
 * @returns
 */
export function getPerfumesByIds(ids) {
  if (isElectron) return getPerfumesByIdsElectron(ids);
  let lang = store.getters.lang;
  let path = `/perfumes/by_ids?lang=${lang}&perfumeIds=${ids.join(
    ","
  )}&allPresent=false&sortByEntryOrder=true`;
  let cached = store.getters["perfumes/get"](lang, path);
  if (cached) return Promise.resolve(cached);

  return instance.get(process.env.VUE_APP_APIURL + path).then((response) => {
    store.dispatch("perfumes/save", { lang, path, objects: response.data });
    return response.data;
  });
}

/** @typedef {import('../types/TopFamilies').TopFamilies} TopFamilies */
/**
 *
 * @param {{lang:string,hostId:number,includeFamilyTopPerfumes:boolean,includeSubFamilyTopPerfumes:boolean}} param0
 * @return {Promise<TopFamilies[]>}
 */
export function getFamiliesTopList({ genders = [], lang = store.state.i18n.lang } = {}) {
  return getFamiliesTopList2(genders, lang);
}
/**
 * @param {{lang:string,hostId:number,includeFamilyTopPerfumes:boolean,includeSubFamilyTopPerfumes:boolean,genders=[]}} param0
 * @return {Promise<TopFamilies>}
 */
export function getFamiliesById(
  id,
  { isPrimary = undefined, genders = [], lang = store.state.i18n.lang } = {}
) {
  if (isPrimary)
    return getFamiliesTopList2(genders, lang).then((res) =>
      res.find((family) => family.id === id)
    );
  else
    return getSubFamiliesTopList(genders, lang).then((res) =>
      res.find((family) => family.id === id)
    );
}
const allPerfumes = {};
const mapPerfumes = {};
const promiseGetAllPerfumes = {};
export async function getAllPerfumes() {
  const lang = store.getters.lang;

  if (promiseGetAllPerfumes[lang]) return await promiseGetAllPerfumes[lang];

  mapPerfumes[lang] = mapPerfumes[lang] || new Map();
  promiseGetAllPerfumes[lang] = instance
    .get(process.env.VUE_APP_APIURL + `/file/catalog`, {
      headers: {
        apikey: process.env.VUE_APP_APIKEY,
        safetyCode: process.env.VUE_APP_SAFETY_CODE,
      },
    })
    .then((response) => response.data)
    .then((perfumes) => {
      allPerfumes[lang] = perfumes;
      perfumes.forEach((perfume) =>
        mapPerfumes[lang].set(perfume.id.toString(), perfume)
      );
      console.log("end all perfumes");
      return perfumes;
    });
  return promiseGetAllPerfumes[lang];
}
export async function getPerfumeByIdElectron(id) {
  const lang = store.getters.lang;
  await getAllPerfumes();
  return mapPerfumes[lang].get(id.toString());
}
export async function getPerfumesByIdsElectron(ids) {
  const perfumes = await Promise.all(ids.map(getPerfumeByIdElectron));
  return perfumes.filter((perfume) => perfume);
}

export default instance;

const getTopFamiliesListGroupedByGender = wrapPromise(
  /** @param {URLSearchParams} qs */ async (qs = new URLSearchParams()) => {
    qs = new URLSearchParams(qs.toString());
    qs.set("includeFamilyTopPerfumes", true);
    qs.set("includeSubFamiliesTopPerfumes", true);
    ["MU", "FU", "U", "FMU"].forEach((gender) => qs.append("genders", gender));
    qs.delete("lang");
    const data = await instance
      .get(
        process.env.VUE_APP_APIURL +
        "/families/top/list/byGender?" +
        qs.toString(),
        {
          // remove: ["lang"],
        }
      )
      .then((res) => res.data);
    return data;
  }
);
export async function getPossibleGenders() {
  const qs = new URLSearchParams();
  qs.set("isPrimary", true);
  const data = await getTopFamiliesListGroupedByGender(qs);
  return Object.keys(data);
}
const getTopFamiliesListGroupedByGenders = wrapPromise((genders, qs) => {
  if (genders.length === 0)
    return getTopFamiliesListGroupedByGender(qs).then((data) => data["FMU"]);
  genders = [
    genders
      .reduce((a, b) => a + b)
      .split("")
      .filter((letter, index, array) => array.indexOf(letter) === index)
      .sort()
      .reduce((a, b) => a + b),
  ];
  return Promise.all(
    genders.map(async (gender) => {
      return getTopFamiliesListGroupedByGender(qs).then((data) => data[gender]);
    })
  )
    .then((arrays) =>
      arrays
        .filter((array) => Array.isArray(array))
        .reduce((a, b) => a.concat(b), [])
    )
    .then((array) => array.filter((e, i) => array.indexOf(e) === i));
});
const getFamiliesTopList2 = wrapPromise(async (genders, lang) => {
  const qs = new URLSearchParams();
  qs.set("lang", lang);
  qs.set("isPrimary", true);
  const data = await getTopFamiliesListGroupedByGenders(genders, qs);
  return data;
});
const getSubFamiliesTopList = wrapPromise(async (genders, lang) => {
  const qs = new URLSearchParams();
  qs.set("lang", lang);
  qs.set("isPrimary", false);

  const data = await getTopFamiliesListGroupedByGenders(genders, qs);
  return data;
});
/**
 *
 * @param {T} callback
 * @return {T}
 * @template {(...args: any[])=>Promise<any>} T
 */
function wrapPromise(callback) {
  var res = {};
  return async function (...args) {
    try {
      if (res[args.toString()]) return res[args.toString()];
      res[args.toString()] = await callback(...args);
      return res[args.toString()];
    } catch (err) {
      console.error(err);
      throw err;
    }
  };
}
